/** Contexto opcional por pantalla (registrado vía hook). */

let activeContext = {};

export function setFlowIAScreenContext(ctx) {
  activeContext = ctx && typeof ctx === 'object' ? { ...ctx } : {};
}

export function getFlowIAScreenContext() {
  return activeContext;
}
